
<template>
  <div ref="listWrap">
    <wrapper-list
      @add="paasAddPage"
      @calculate="paasCalculate"
      wTitle="组合数据"
      wIicon="md-albums"
      ref="wrapperList" >
      <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
        <row class="list-query-row">
          <FormItem label="数据组名称" class="list-query-item">
            <Input  v-model="queryParam.query_LIKE_name" placeholder=""
                    @on-change="queryTableDatas" clearable />
          </FormItem>
          <FormItem label="数据提示" class="list-query-item">
            <Input  v-model="queryParam.query_LIKE_info" placeholder=""
                    @on-change="queryTableDatas" clearable />
          </FormItem>
          <FormItem label="数据字段" class="list-query-item">
            <Input  v-model="queryParam.query_LIKE_configName" placeholder=""
                    @on-change="queryTableDatas" clearable />
          </FormItem>
        </row>
      </Form>
      <Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
      </Table>
      <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
      </Page>
    </wrapper-list>
  </div>
</template>
<script>
  import wrapperList from "@/components/paas/wrapper-list";
  import metaList from "@/assets/js/list/meta-list.js";
  import CellBar from '@/components/paas/cell-bar' //列表内操作
  export default {
    name: "list",
    mixins: [ metaList ],
    components: { wrapperList  ,CellBar},
    data() {
      return {
        serviceUrl:"/eb/system/group",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        queryParam:{
          query_LIKE_name:"",
          query_LIKE_info:"",
          query_LIKE_configName:"",
        },
        defaultLabelWidth:200,
        tableColumns:[
          {
            type: 'index',  //type: 'index'，可以排序
            width: 40,
            align: 'center',
          },
          {
            title: 'key',
            key: 'configName',
          },
          {
            title: '数据组名称',
            key: 'name',
          },
          {
            title: '数据简介',
            key: 'info',
          },
          {
            title: '操作',
            render: (h, params) => {
              return h(CellBar,
                {
                  props:{
                    show:'textIcon'  //操作也显示标准按钮的样式（text、icon、textIcon）
                  },
                  //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                  on: {
                    // 子组件$emit传递函数,必须是箭头函数写法
                    'edit': ()=> {
                      this.$nextTick(()=>{
                        this.paasEditOper(params.row[this.currentIdFiledName]);
                      })
                    },
                    'delete':()=>{
                      this.$nextTick(()=>{
                        this.paasDeleteOper(params.row[this.currentIdFiledName]);
                      })
                    },
                    'detail':()=>{
                      this.$nextTick(()=>{
                        this.paasDetailOper(params.row[this.currentIdFiledName]);
                      })
                    },
                    /**
                     * 打开数据列表
                     */
                    'openListTag':()=>{
                      this.$nextTick(()=>{
                        let url = "/eb/system/group/data/list?configName="+params.row.configName;
                        this.$router.push({'path': this.setUrlFuncId(url)});
                      })
                    },
                  }
                }
              )
            }
          }
        ],
      }
    },
    mounted(){
    },
    methods:{
    }
  }
</script>
